import {
	LIST_ORG_REQUEST,
	LIST_ORG_SUCCESS,
	LIST_ORG_FAIL,
	LIST_ORG_RESET,
	GET_ORG_STATUS_REQUEST,
	GET_ORG_STATUS_SUCCESS,
	GET_ORG_STATUS_FAIL,
	GET_ORG_STATUS_RESET,
	ADD_ORG_REQUEST,
	ADD_ORG_SUCCESS,
	ADD_ORG_FAIL,
	ADD_ORG_RESET,
	UPDATE_ORG_REQUEST,
	UPDATE_ORG_SUCCESS,
	UPDATE_ORG_FAIL,
	UPDATE_ORG_RESET,
	DELETE_ORG_REQUEST,
	DELETE_ORG_SUCCESS,
	DELETE_ORG_FAIL,
	DELETE_ORG_RESET
} from '../constants/orgConstants';

export const orgsListReducer = (state = {}, action) => {
	switch (action.type) {
		case LIST_ORG_REQUEST:
			return { loading: true };

		case LIST_ORG_SUCCESS:
			return { orgs: action.payload, loading: false };

		case LIST_ORG_FAIL:
			return { loading: false, error: action.payload };

		case LIST_ORG_RESET:
			return {};

		default:
			return state;
	}
};

export const orgStatusReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_ORG_STATUS_REQUEST:
			return { loading: true };

		case GET_ORG_STATUS_SUCCESS:
			return { orgs: action.payload, loading: false };

		case GET_ORG_STATUS_FAIL:
			return { loading: false, error: action.payload };

		case GET_ORG_STATUS_RESET:
			return {};

		default:
			return state;
	}
};

export const addOrgReducer = (state = {}, action) => {
	switch (action.type) {
		case ADD_ORG_REQUEST:
			return { loading: true };

		case ADD_ORG_SUCCESS:
			return { data: action.payload, loading: false };

		case ADD_ORG_FAIL:
			return { loading: false, error: action.payload };

		case ADD_ORG_RESET:
			return {};

		default:
			return state;
	}
};

export const updateOrgReducer = (state = {}, action) => {
	switch (action.type) {
		case UPDATE_ORG_REQUEST:
			return { loading: true };

		case UPDATE_ORG_SUCCESS:
			return { org: action.payload, loading: false };

		case UPDATE_ORG_FAIL:
			return { loading: false, error: action.payload };

		case UPDATE_ORG_RESET:
			return {};

		default:
			return state;
	}
};

export const deleteOrgReducer = (state = {}, action) => {
	switch (action.type) {
		case DELETE_ORG_REQUEST:
			return { ...state, loading: true };

		case DELETE_ORG_SUCCESS:
			return { org: action.payload, loading: false };

		case DELETE_ORG_FAIL:
			return { loading: false, error: action.payload };

		case DELETE_ORG_RESET:
			return {};

		default:
			return state;
	}
};
